import { render, staticRenderFns } from "./DialogEmailEdit.vue?vue&type=template&id=00868e01&"
import script from "./DialogEmailEdit.vue?vue&type=script&lang=js&"
export * from "./DialogEmailEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports